<template>
  <v-container>
    <v-card
      color="oug"
      class="pa-1 mx-auto text-center justify-center"
      max-width="600"
      elevation="24"
    >
      <v-card-title class="text-h6 white--text">Videos</v-card-title>
      <v-card-subtitle class="white--text" align="start">
        This section full size clinics from 60 minutes upwards. There is several
        different presenters in this section both locally and internationally.
      </v-card-subtitle>
      <div>
      <v-dialog
      v-model="loadingDialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="oug"
        dark
      >
        <v-card-text>
          Loading Videos. Please Stand By
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    </div>
      <v-expansion-panels focusable>
        <v-expansion-panel v-for="(video, i) in Videos" :key="i">
          <v-expansion-panel-header
            >{{ video.category }}
            <v-spacer></v-spacer>
          </v-expansion-panel-header>
          <p></p>
          <v-expansion-panel-content
            class="justify-start"
            v-for="(item, i) in video.items"
            :key="i"
          >
            <v-row no-gutters>
              <p @click="openVideo(item.url)">{{ item.title }}</p>
            </v-row>
            <v-divider></v-divider>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-card>
  </v-container>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      Videos: [],
      result: [],
      loadingDialog: false
    };
  },
  created() {
    this.loadVideos();
  },
  methods: {
    loadVideos() {
      // Load Documents from the Referees App
      const payload = {
        Team_id: 660,
      };
      this.loadingDialog = true;
      const baseURL = "https://server.ownurgoal.net.au/gen/GetTeamVideos";
      axios.post(baseURL, payload).then((response) => {
        // Create axios call to get result
        const results = response.data.result;
        // console.log("results check 2", results)
        // Do for loop to loop through each item in Results array
        results.forEach((result) => {
          // console.log("2")
          // Firstly check category name in documents array (for all records)
          if (result.type == "Team Videos") {
            let videoIndex = this.Videos.findIndex((element) => {
              return element.category == result.Category;
            });
            if (videoIndex == -1) {
              // Option A: No category found
              this.Videos.push({
                category: result.Category,
                items: [],
              });
              let currentVid = this.Videos.length - 1;
              this.Videos[currentVid].items.push({
                title: result.Title,
                url: result.url,
              });
              this.loadingDialog = false;
            } else {
              // Option B: Category found = n in the Documents array
              this.Videos[videoIndex].items.push({
                title: result.Title,
                url: result.url,
              });
            }
          }
        });
      });
    },
    openVideo(url) {
      this.$router.push(`/showVideo/${url},youtube`);
    },
  },
};
</script>